/**
 * Catalogo autorizado e concessao de embed. O backend decide o acesso; a tela so pede.
 *
 * As rotas vivem sob `/reports`, e NAO sob `/dashboards`: o modulo do backend ainda se chama
 * `dashboards.py` ("mantem o nome do modulo por compatibilidade"), mas o router e registrado com
 * `prefix="/reports"`. Deduzir o caminho pelo nome do arquivo custou um 404 em producao.
 */

import { apiGet, apiPost, type Envelope } from './client'
import type { EmbedToken, IntelGraphEmbed, ReportListItem } from './types'

export async function listReports(): Promise<ReportListItem[]> {
  const resposta = await apiGet<Envelope<ReportListItem>>('/reports')
  return resposta.rows
}

/**
 * Pede a concessao de embed para UM relatorio.
 *
 * E aqui que o RLS acontece, do lado do servidor: o backend resolve a Access Policy do usuario,
 * monta a EffectiveIdentity e pede o token ao PowerBI. A tela nunca ve roles nem identidade - se
 * visse, o recorte de dados passaria a depender de algo que o navegador pode alterar.
 */
export function fetchEmbedToken(reportId: string): Promise<EmbedToken> {
  return apiPost<EmbedToken>('/reports/embed-token', { report_id: reportId })
}

/**
 * URL de embed de um relatorio do New Inteli Graph.
 *
 * Quem fala com o NIG e o BACKEND, de servidor para servidor. No app Streamlit quem emitia era o
 * frontend - que rodava no servidor e alcancava o NIG pelo nome do container; do navegador, esse
 * nome nao existe.
 */
export function fetchIntelGraphEmbed(reportId: string): Promise<IntelGraphEmbed> {
  return apiPost<IntelGraphEmbed>('/reports/inteli-graph-embed', { report_id: reportId })
}
